module.exports = __webpack_public_path__ + "assets/pdf/灣仔體育總會有限公司-會員申請表.pdf";